import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { VehiclePreloader } from 'site-modules/shared/utils/core-page/vehicle-preloader-v2';
import { ConsumerReviewsModel, ConsumerReviewsPaths } from 'client/data/models/consumer-reviews';
import { buildMMYSubmodelTrimPhotosPathWithParams, PhotosModel } from 'client/data/models/photos';
import { WriteReview } from './write-review';

const PAGE_NAME = 'model_write_consumer_review';
const PAGE_CATEGORY = 'model_core';

export const getPageOptions = params => ({
  name: PAGE_NAME,
  category: PAGE_CATEGORY,
  component: props => <WriteReview {...props} vehicleParams={params} isConfirmed={!!params.reviewId} />,
  preload: (store, props) => {
    const preloader = new VehiclePreloader(store, { ...props, params });
    preloader.set(ConsumerReviewsPaths.getVehicleFilterPath(), ConsumerReviewsModel, { params });
    if (params.reviewId) {
      preloader.set(ConsumerReviewsPaths.getCreateAndUpdateReviewIdPath(), ConsumerReviewsModel, params.reviewId);
    } else {
      preloader.resolve(buildMMYSubmodelTrimPhotosPathWithParams(params), PhotosModel);
    }

    return preloader.load();
  },
  seo: {
    robots: {
      noIndex: true,
    },
  },
  options: {
    hasVehicleContext: true,
  },
});

export default params => pageDefinition(getPageOptions(params));
